import React, { useEffect } from "react";
import { inject, observer } from "mobx-react";
import DashboardService from "./DashboardService";
import { DataForm } from "../../../libs/react-mpk/components";
import moment from "moment";

import {
  SortOrder,
  TableContainer,
  Table,
  TableHeader,
  TableRow,
  TableCell,
  TableBody,
  Caption,
} from "@react-md/table";
import { FontIcon } from "@react-md/icon";
import {
  AppBar,
  AppBarNav,
  AppBarTitle,
  AppBarAction,
} from "@react-md/app-bar";
import { useState } from "react";
import { Line, Circle } from "rc-progress";
import Utils from "../../../libs/custom/Utils";
import { Avatar, Card, CardHeader, CardSubtitle, CardTitle } from "react-md";

function KontribusiPajakDashboardView({ sipStore }) {
  const [data, setData] = useState({
    loading: true,
    content: [],
    sortKey: "totalPph",
    sortOrder: "ascending",
    total: 0,
    param: {},
  });

  const [toggleFilter, setToggleFilter] = useState(false);

  useEffect(() => {
    initData("totalPph", {
      perusahaanId: sipStore.companyId,
      from: moment().startOf("month").format("YYYY-MM-DD"),
      to: moment().endOf("month").format("YYYY-MM-DD"),
      type: "Pajak Terutang",
    });
  }, []);

  async function initData(sortKey, param) {
    var d = data.content;
    if (param) {
      var res = await DashboardService.kontribusiPajak(param);
      d = res.data;
    }

    setData((prevState) => {
      const prevSortKey = prevState.sortKey;
      const prevSortOrder = prevState.sortOrder;


      let sortOrder = prevSortOrder;
      if(sortKey) {
        if (sortKey === prevSortKey) {
          // it's the same column, so toggle the sort order
          sortOrder = prevSortOrder === "ascending" ? "descending" : "ascending";
        } else {
          // it's a new column to sort by, so default to ascending for the name column
          // but descending for all the rest.
          sortOrder = sortKey === "name" ? "ascending" : "descending";
        }
      }

      if(!sortKey) sortKey = prevSortKey;

      return {
        content: d.sort((a, b) => {
          const aValue = a[sortKey];
          const bValue = b[sortKey];
          const value =
            typeof aValue === "number"
              ? aValue - bValue
              : "" + aValue.localeCompare(bValue);
          return value * (sortOrder === "ascending" ? 1 : -1);
        }),
        sortKey,
        sortOrder,
        param: {
          ...prevState.param,
          ...param
        },
        loading: false,
        total: d.reduce((pv, cv) => {
          pv = pv + cv.totalPph;
          return pv;
        }, 0),
      };
    });
  }

  const { content, sortKey, sortOrder } = data;

  return (
    <Card  raiseable
      className="mpk-form-wrapper mpk-paper  padding-all mpk-animation slide-in"
      style={{
        width: "49%",
        maxWidth: 1200,
        margin: "0px auto",
        marginRight: "2%",
        display: "inline-block",
      }}
    >
      <CardHeader
        beforeChildren={
          <Avatar >
            <FontIcon iconClassName="mdi mdi-calendar-text"/>
          </Avatar>
        }
        afterChildren={
          <AppBarAction first aria-label="Actions" onClick={()=> {setToggleFilter(!toggleFilter)}}>
          <FontIcon iconClassName="mdi mdi-filter" />
        </AppBarAction>
        }
      >
        <CardTitle>KONTRIBUSI PAJAK</CardTitle>
        {/* <CardSubtitle>Daftar pembelian berdasarkan COA</CardSubtitle> */}
      </CardHeader>
      <div className="mpk-padding-N" style={{ height: 600, overflow: "auto" }}>
        {toggleFilter && (
          <DataForm
            baseId={"pegawai-import"}
            // asDialog={true}
            defaultData={data.param}
            definitions={[
              {
                inputType: DataForm.inputTypes.DATEPICKER,
                label: "Dari Tanggal",
                key: "from",
                theme: "filled",
                validation: "required",
                style: { marginRight: "2%", width: "49%" },
              },
              {
                inputType: DataForm.inputTypes.DATEPICKER,
                label: "Ke Tanggal",
                key: "to",
                theme: "filled",
                validation: "required",
                style: { width: "49%" },
              },
              {
                inputType: DataForm.inputTypes.SELECT,
                label: "Kategori Pajak",
                key: "type",
                theme: "filled",
                validation: "required",
                options: [
                  { label: "Pajak Terutang", value: "Pajak Terutang" },
                  {
                    label: "Pajak Dibayar Dimuka",
                    value: "Pajak Dibayar Dimuka",
                  },
                ],
                style: { width: "29%" },
              },
            ]}
            // visible={uploadModal}
            submitLabel="Cari"
            onSubmit={async (d, callback) => {
              try {
                console.log(d, 'dd')
                await initData(null, {
                  ...d,
                  perusahaanId: sipStore.companyId,
                });
                callback();
              } catch (e) {
                console.log(e.response);
                callback(e.response.data.message);
              }
            }}
          />
        )}
        <TableContainer>
          <Table fullWidth>
            <Caption>{data.param.from} - {data.param.to} {data.param.type}</Caption>
            <TableHeader>
              <TableRow>
                <TableCell
                  key="nama"
                  aria-sort={"nama" === sortKey ? sortOrder : "none"}
                  onClick={() => initData("nama")}
                >
                  CABANG
                </TableCell>
                <TableCell
                  key="totalPph"
                  aria-sort={"totalPph" === sortKey ? sortOrder : "none"}
                  onClick={() => initData("totalPph")}
                  style={{ textAlign: "right" }}
                >
                  NOMINAL
                </TableCell>
                <TableCell style={{ width: 200 }}>PERSENTASE</TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHeader>
            <TableBody>
              {data.content.map((v, i) => {
                var c = colors[getRandomInt(34, 0)];
                return (
                  <TableRow>
                    <TableCell>
                      <div style={{}}>{v.nama}</div>
                    </TableCell>
                    <TableCell style={{ textAlign: "right" }}>
                      {Utils.numberFormat(v.totalPph)}
                    </TableCell>
                    <TableCell>
                      {v.totalPph > 0 && <Line
                        percent={(v.totalPph / data.total) * 100}
                        strokeWidth={4}
                        strokeColor={colors[getRandomInt(34, 0)]}
                      />}

                    </TableCell>
                    <TableCell>
                      {Utils.numberFormat((v.totalPph / data.total) * 100)}%
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </Card>
  );
}

export default inject(
  "sipStore",
  "authStore"
)(observer(KontribusiPajakDashboardView));

const colors = [
  "#ef5350",
  "#ff1744",
  "#ec407a",
  "#f50057",
  "#ab47bc",
  "#d500f9",
  "#7e57c2",
  "#651fff",
  "#5c6bc0",
  "#3d5afe",
  "#42a5f5",
  "#2979ff",
  "#29b6f6",
  "#00b0ff",
  "#26c6da",
  "#00e5ff",
  "#26a69a",
  "#1de9b6",
  "#66bb6a",
  "#00e676",
  "#9ccc65",
  "#76ff03",
  "#d4e157",
  "#c6ff00",
  "#ffee58",
  "#ffea00",
  "#ffca28",
  "#ffc400",
  "#ffa726",
  "#ff9100",
  "#ff7043",
  "#ff3d00",
  "#8d6e63",
  "#bdbdbd",
  "#78909c",
];

function getRandomInt(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
}
